module.exports = __webpack_public_path__ + "static/media/circle.082528b3.svg";